import React from "react";
import VentasForm from "../../components/VentasForm";
import Navbar from "../../components/Navbar";

const Venta = () => {
  return (
    <div className="container">
      <Navbar />

      <VentasForm />
    </div>
  );
};

export default Venta;
